import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import PersonValidationResponse from 'src/models/responseTypes/PersonValidationResponse';

export type ShareholderValidateDataState = {
  shareholderValidateData: PersonValidationResponse;
};

export const initialState: ShareholderValidateDataState = {
  shareholderValidateData: {
    isValidPerson: true,
    personExist: false,
    possibleIssue: null,
  },
};

const shareholderValidateSlice = createSlice({
  name: 'shareholderValidateSlice',
  initialState,
  reducers: {
    overwritePerson: (
      _,
      action: PayloadAction<ShareholderValidateDataState>,
    ): ShareholderValidateDataState => {
      return action.payload;
    },
    updateSearchValidateShareholder: (
      state,
      action: PayloadAction<PersonValidationResponse>,
    ): void => {
      state.shareholderValidateData = action.payload;
    },
  },
});

export const { overwritePerson, updateSearchValidateShareholder } =
  shareholderValidateSlice.actions;

export default shareholderValidateSlice.reducer;
